import { render } from "./AdminPosts.vue?vue&type=template&id=6d252858"
import script from "./AdminPosts.vue?vue&type=script&lang=js"
export * from "./AdminPosts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__